import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

interface ActivityTypeFilterProps {
  filterValue: string | null;
  updateFilters: (value: string | null) => void;
  disabled?: boolean;
}

const activityTypes = {
  all: 'All',
  initiation: 'Initiation',
  transfer: 'Transfer',
  reinstatement: 'Reinstatement',
  inactive: 'Inactivity',
  death: 'Death',
};

const ActivityTypeFilter: React.FC<ActivityTypeFilterProps> = ({
  filterValue,
  updateFilters,
  disabled = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    updateFilters(value === 'all' ? null : value);
  };

  return (
    <FormControl fullWidth variant="outlined" size="small">
      <InputLabel id="activity-type-label">Activity Type</InputLabel>
      <Select
        labelId="activity-type-label"
        id="activity-type-select"
        disabled={disabled}
        fullWidth
        value={filterValue || 'all'}
        label="Activity Type"
        onChange={handleChange}
      >
        {Object.keys(activityTypes).map((key) => (
          <MenuItem key={key} value={key}>
            {activityTypes[key as keyof typeof activityTypes]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ActivityTypeFilter;
